/**
 * ISMOOLI Collection page enhancements.
 * Grid density toggle and mobile filter drawer trigger.
 */
(function () {
  const STORAGE_KEY = 'glyc-collection-grid-density';

  function initGridDensity() {
    const grids = document.querySelectorAll('[data-glyc-product-grid]');
    const buttons = document.querySelectorAll('[data-glyc-grid-density]');

    if (!grids.length || !buttons.length) return;

    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved) {
      grids.forEach((grid) => grid.setAttribute('data-glyc-grid-density', saved));
      buttons.forEach((button) => {
        const isActive = button.dataset.glycGridDensity === saved;
        button.classList.toggle('glyc-collection-toolbar__view-btn--active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const density = button.dataset.glycGridDensity;
        if (!density) return;

        grids.forEach((grid) => grid.setAttribute('data-glyc-grid-density', density));
        buttons.forEach((item) => {
          const isActive = item === button;
          item.classList.toggle('glyc-collection-toolbar__view-btn--active', isActive);
          item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        window.localStorage.setItem(STORAGE_KEY, density);
      });
    });
  }

  function initMobileFilterTrigger() {
    const trigger = document.querySelector('[data-glyc-filter-trigger]');
    const mobileFacetsOpen = document.querySelector('.mobile-facets__open-wrapper');

    if (!trigger || !mobileFacetsOpen) return;

    trigger.addEventListener('click', () => {
      mobileFacetsOpen.click();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initGridDensity();
      initMobileFilterTrigger();
    });
  } else {
    initGridDensity();
    initMobileFilterTrigger();
  }
})();
